@if (card && !card.isDownload) {
    @if (card && !loading) {
        <a
            [attr.aria-labelledby]="`${cardNameId(card)}-title`"
            [attr.aria-describedby]="`${cardNameId(card)}-description`"
            [ngClass]="getCardClasses()"
            [class.card--border]="showBorder"
            [class.card--box-shadow]="showBoxShadow"
            [class.card--title-primary]="cardPrimaryHeader"
            [class.card--image-align-center]="iconImageAlignment === 'center'"
            [class.card--image-align-left]="iconImageAlignment === 'left'"
            [class.card--image-align-right]="iconImageAlignment === 'right'"
            [class.card--image-icons]="isIconImage"
            [style.background-color]="cardBackgroundColor || null"
            [style.--card-box-shadow-color]="cardBoxShadowColor || null"
            [style.--card-title-color]="cardTitleColor || null"
            [style.--card-title-font-size]="cardTitleFontSize || null"
            [style.--card-title-font-weight]="cardTitleFontWeight || null"
            [routerLink]="fullUrl(card)"
            [title]="card.name"
            [id]="cardNameId(card)"
            class="card h-100 benefit-card card--image-{{ imageSize }}"
            href="javascript:void(0)">
            @if (imageUrl && displayImages) {
                <div class="card-img-wrapper card-img-top">
                    <div [ngClass]="pageGradient" class="card-img-front">
                        <img [alt]="card.name" [src]="imageUrl" class="img-fluid" />
                    </div>
                </div>
            }
            @if (!imageUrl && displayImages) {
                <div class="card-img-wrapper card-img-top card-img-placeholder"></div>
            }
            <div class="card-body">
                <div class="card-text">
                    @if (
                        cardType !== 'life-journeys' ||
                        wrapperType === 'keyword-content' ||
                        wrapperType === 'related-content'
                    ) {
                        <div [innerHtml]="getTitle()" class="card-text__sub-title"></div>
                    }
                    <h3
                        class="card-title"
                        [ngClass]="{ 'card-title__arrow': showTitleArrow }"
                        [id]="`${cardNameId(card)}-title`">
                        @if (showTitleArrow) {
                            <span class="card-title__text">{{ card.name }}</span>
                            <span class="arrow">
                                <svg
                                    class="ms-2"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="18"
                                    height="14"
                                    viewBox="0 0 18 14"
                                    fill="none">
                                    <path
                                        d="M1 7H17M11 13L17 7L11 1"
                                        stroke="var(--color-primary)"
                                        stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </svg>
                            </span>
                        } @else {
                            {{ card.name }}
                        }
                    </h3>
                    @if (card.description) {
                        <p [innerText]="card.description | limitTo: 175" [id]="`${cardNameId(card)}-description`"></p>
                    }
                </div>
                @if (displayTags) {
                    <div class="card-footer">
                        <core-block-tags
                            [enableLinks]="true"
                            [tags]="(card.tags ?? []).slice(0, 3)"
                            [zone]="card.zone"></core-block-tags>
                    </div>
                }
                @if (cardLinkText) {
                    <div
                        class="card__link-text d-inline-flex align-items-center gap-2"
                        [style.color]="resolvedLinkColor || null">
                        <span>{{ cardLinkText }}</span>
                        @if (includeCtaIcon) {
                            <core-icon
                                class="card__link-icon"
                                aria-hidden="true"
                                [name]="buttonIcon ?? ''"
                                [size]="16"
                                [style.color]="'currentColor'"></core-icon>
                        }
                    </div>
                }
            </div>
        </a>
    }
}

@if (card && card.isDownload && card.token) {
    @if (card && !loading) {
        <a
            (click)="downloadItem(card.token)"
            [ngClass]="getPillar()"
            [title]="card.name"
            [class.card--image-align-center]="iconImageAlignment === 'center'"
            [class.card--image-align-left]="iconImageAlignment === 'left'"
            [class.card--image-align-right]="iconImageAlignment === 'right'"
            [class.card--image-icons]="isIconImage"
            [class.card--title-primary]="cardPrimaryHeader"
            [class.card--box-shadow]="showBoxShadow"
            [style.background-color]="cardBackgroundColor || null"
            [style.--card-box-shadow-color]="cardBoxShadowColor || null"
            [style.--card-title-color]="cardTitleColor || null"
            [style.--card-title-font-size]="cardTitleFontSize || null"
            [style.--card-title-font-weight]="cardTitleFontWeight || null"
            class="card h-100 text-decoration-none"
            href="javascript:void(0)">
            <div class="card-img-wrapper card-img-top">
                <div [ngClass]="pageGradient" class="card-img-front">
                    <img [alt]="card.name" [src]="imageUrl" class="img-fluid" />
                </div>
            </div>
            <div class="card-body">
                <div class="card-text">
                    @if (cardType !== 'life-journeys' && cardType !== 'page') {
                        <div [innerHtml]="getTitle()" class="card-text__sub-title"></div>
                    }
                    <h3 class="card-title" [ngClass]="{ 'card-title__arrow': showTitleArrow }">
                        @if (showTitleArrow) {
                            <span class="card-title__text">{{ card.name }}</span>
                            <span class="arrow">
                                <svg
                                    class="ms-2"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="18"
                                    height="14"
                                    viewBox="0 0 18 14"
                                    fill="none">
                                    <path
                                        d="M1 7H17M11 13L17 7L11 1"
                                        stroke="var(--color-primary)"
                                        stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </svg>
                            </span>
                        } @else {
                            {{ card.name }}
                        }
                    </h3>
                    @if (card.description) {
                        <p [innerText]="card.description | limitTo: 175"></p>
                    }
                </div>
                @if (displayTags) {
                    <div class="card-footer">
                        <core-block-tags [tags]="card.tags ?? []" [zone]="card.zone"></core-block-tags>
                    </div>
                }
            </div>
        </a>
    }
}

@if (loading) {
    <core-block-card-shimmer></core-block-card-shimmer>
}
